import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CloneCaseStudyModal = ({
  caseStudyName,
  onConfirm,
  onReject,
  isCloningCaseStudy
}) => {
  const [cloneName, setCloneName] = useState(I18n.text('caseStudyEditor.childMenuItems.clone.inputDefaultName', {
    caseStudyName
  }) || '');
  const handleCloneNameChange = ({
    currentTarget: {
      value
    }
  }) => {
    setCloneName(value);
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    onEsc: onReject,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: onReject
    }), /*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "caseStudyEditor.childMenuItems.clone.header",
          options: {
            caseStudyName
          }
        })
      })
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "caseStudyEditor.childMenuItems.clone.info",
          options: {
            caseStudyName
          }
        }),
        children: /*#__PURE__*/_jsx(UITextInput, {
          onChange: handleCloneNameChange,
          value: cloneName
        })
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UILoadingButton, {
        "data-test-id": "category-modal-ok",
        keepResultAfterFinish: true,
        loading: isCloningCaseStudy,
        onClick: () => onConfirm(cloneName),
        spinnerProps: {
          resultAnimationDuration: 1000
        },
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "caseStudyEditor.childMenuItems.clone.buttons.confirm"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: onReject,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "caseStudyEditor.childMenuItems.clone.buttons.cancel"
        })
      })]
    })]
  });
};
export default CloneCaseStudyModal;